export default "__VITE_ASSET__CecRcstS__"